'use client';

import {useLogin, usePrivy} from "@privy-io/react-auth";
import {useRouter} from "next/navigation";
import LoginButton from "@/app/components/LoginButton";
import {close} from "@/lib/redux/slices/menuSlice";
import {useAppDispatch} from "@/lib/redux/hooks";

export default function PrivyLogin() {
    const {ready} = usePrivy();
    const router = useRouter();
    const dispatch = useAppDispatch();

    const {login} = useLogin({
        onComplete: () => {
            dispatch(close());
            router.push('/', {scroll: false});
        },
        onError: (error) => {
            // do nothing
        }
    });

    const isDisabled = !ready;

    return (
        <LoginButton
            onClick={login}
            disabled={isDisabled}>
            LOGIN
        </LoginButton>
    );
}